import { createStore } from 'redux';
import { createReducerManager } from './ReducerManager';

const rootReducer = (state = {}, action = { type: null }) => {
  return state;
};

const reducerManager = createReducerManager({ root: rootReducer });

/* Create a store with the root reducer function being the one exposed by the manager. */
const store = createStore(
  reducerManager.reduce,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

/* Optional: Put the reducer manager on the store so it is easily accessible */
store.reducerManager = reducerManager;
window.reducerManager = reducerManager;
window.store = store;

console.log('Store created');
export default store;
